module.exports = __webpack_public_path__ + "media/images/top/original-e362491be4f47476a18140c0fb4539ae.jpg";